import { Box, Button, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Dispatch, SetStateAction, useEffect } from "react";
import { AddOnItemName, UpgradeDialogSource } from "schemas/dashboard";

import StyledDialog from "components/Styled/Dialog";
import { trackEvent } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

interface Props {
  open: boolean;
  handleClose: () => void;
  onDecline: () => void;
  setAlreadyShownCopywriterOffer: Dispatch<SetStateAction<boolean>>;
}

const CopywriterOfferDialog = ({
  open,
  handleClose,
  onDecline,
  setAlreadyShownCopywriterOffer,
}: Props) => {
  const { handleCheckoutAddOnDialog } = useSubscription();

  const handleYes = () => {
    trackEvent("Copywriter Template Offer - Accepted");
    handleCheckoutAddOnDialog(
      UpgradeDialogSource.copywriter_template_offer,
      AddOnItemName.pitching_templates,
    );
    setAlreadyShownCopywriterOffer(true);
    handleClose();
  };

  const handleNo = () => {
    trackEvent("Copywriter Template Offer - Declined");
    onDecline();
  };

  useEffect(() => {
    if (open) {
      trackEvent("Copywriter Template Offer - Dialog Opened");
    }
  }, [open]);

  return (
    <StyledDialog
      open={open}
      handleClose={handleClose}
      title={
        <>
          Need <em>human</em> help? 👀
        </>
      }
      centered
      maxWidth="sm"
    >
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Typography sx={{ color: grey[600], mb: 4 }}>
          Our <strong>professional copywriters</strong> can create a
          high-converting pitch template tailored to your personal need.
        </Typography>

        <Box
          sx={{
            backgroundColor: "purple.light",
            borderRadius: 3,
            p: 3,
            mb: 4,
          }}
        >
          <Typography variant="h4" gutterBottom>
            What you'll get:
          </Typography>
          <Grid container spacing={2} sx={{ textAlign: "left", mt: 1 }}>
            <Grid item xs={12}>
              <Typography>
                <Box
                  component="i"
                  className="fa-solid fa-check"
                  sx={{ color: "green.main", mr: 1 }}
                />
                Professionally written pitch template
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <Box
                  component="i"
                  className="fa-solid fa-check"
                  sx={{ color: "green.main", mr: 1 }}
                />
                Customized to your tone and style
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                <Box
                  component="i"
                  className="fa-solid fa-check"
                  sx={{ color: "green.main", mr: 1 }}
                />
                Increase response rate up to <strong>300%</strong>
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleNo}
              sx={{
                py: 1.5,
                textTransform: "none",
                borderColor: grey[300],
                color: grey[700],
              }}
            >
              No thanks, I'll do it myself
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              variant="contained"
              disableElevation
              onClick={handleYes}
              sx={{ py: 1.5, textTransform: "none" }}
            >
              Yes, get help for $30
            </Button>
          </Grid>
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default CopywriterOfferDialog;
